module.exports = __webpack_public_path__ + "img/cra.ed5eec61.png";